import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type {WaypointNode} from '~/models/journey/waypoints'
import type {Path} from '~/types/util'

export class CheckupDuringAepNode extends DecisionNodeBase {
    getNext(): WaypointNode | Path | null {
        const {flag} = FeatureFlags.use()
        const isAep = computed(() => flag('is-aep', false).value)

        return this.yesNo(isAep.value)
    }
}
